<template>
	<div class="c-body">
		<div class="c-body__title">
			<h2>
				RatioCalc
				<button @click="toggleHelp" :class="{'-active': showHelp}">
					<c-icon :name="'question-circle'"></c-icon>
				</button>
			</h2>
		</div>
		<div class="c-help">
			<div class="c-help__inner">
				<div class="e-section">
					<p>
						黄金比・白銀比計算機。
						結果は小数点第4位で丸められます。
					</p>
				</div>
			</div>
		</div>
		<div class="c-body__inner">
			<div class="e-section">
				<div class="e-grid -double">
					<div class="col">
						<p>
							<label class="e-label">
								<span class="label">数字を入力してください : </span>
								<input type="number" class="e-input-text -center -remark" v-model="input" @change="calculate" @keyup="calculate">
							</label>
						</p>
						<hr class="e-hr">
						<div class="c-ratiocalc-result">
							<div class="c-ratiocalc-result__item" :class="{'-active': type === 'golden'}">
								<div class="c-ratiocalc-result__label">
									<label class="e-label">
										<input type="radio" name="type" value="golden" v-model="type">
										<span class="label">黄金比 <small>Golden Ratio</small></span>
									</label>
								</div>
								<ul class="c-ratiocalc-result__field">
									<li class="c-ratiocalc-result__field-row">
										<input type="text" class="e-input-text -center -small -remark" readonly v-model="input">
										<span class="c-ratiocalc-result__gutter">:</span>
										<input type="text" class="e-input-text -center -small" readonly v-model="result.golden.large">
									</li>
									<li class="c-ratiocalc-result__field-row">
										<input type="text" class="e-input-text -center -small" readonly v-model="result.golden.small">
										<span class="c-ratiocalc-result__gutter">:</span>
										<input type="text" class="e-input-text -center -small -remark" readonly v-model="input">
									</li>
								</ul>
							</div>
							<div class="c-ratiocalc-result__item" :class="{'-active': type === 'silver'}">
								<div class="c-ratiocalc-result__label">
									<label class="e-label">
										<input type="radio" name="type" value="silver" v-model="type">
										<span class="label">白銀比 <small>Silver Ratio</small></span>
									</label>
								</div>
								<ul class="c-ratiocalc-result__field">
									<li class="c-ratiocalc-result__field-row">
										<input type="text" class="e-input-text -center -small -remark" readonly v-model="input">
										<span class="c-ratiocalc-result__gutter">:</span>
										<input type="text" class="e-input-text -center -small" readonly v-model="result.silver.large">
									</li>
									<li class="c-ratiocalc-result__field-row">
										<input type="text" class="e-input-text -center -small" readonly v-model="result.silver.small">
										<span class="c-ratiocalc-result__gutter">:</span>
										<input type="text" class="e-input-text -center -small -remark" readonly v-model="input">
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="col">
						<div class="c-ratiocalc-preview" :class="{'-silver': type === 'silver'}">
							<div class="c-ratiocalc-preview__large">
								<span class="c-ratiocalc-preview__tip -top">
									{{type === "golden" ? result.golden.large : result.silver.large}}
								</span>
								<span class="c-ratiocalc-preview__tip -right">{{input}}</span>
								<div class="c-ratiocalc-preview__small">
									<span class="c-ratiocalc-preview__tip -top">{{input}}</span>
									<span class="c-ratiocalc-preview__tip -right">
										{{type === "golden" ? result.golden.small : result.silver.small}}
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import mCommon from "../mixins/common";


export default {
	mixins: [
		mCommon
	],
	data (){
		return {
			type: "golden",
			input: 1024,
			result: {
				golden: {
					large: 0,
					small: 0,
				},
				silver: {
					large: 0,
					small: 0,
				}
			},
			rate: {
				golden: 1.618,
				silver: 1.414,
			}
		};
	},
	mounted (){
		this.calculate();

	},
	methods: {
		calculate() {
			var input = parseInt(this.input, 10) || 1024;

			// 黄金比計算
			this.result.golden.large = this.round(this.input * this.rate.golden);
			this.result.golden.small = this.round(this.input / this.rate.golden);

			// 白銀比計算
			this.result.silver.large = this.round(this.input * this.rate.silver);
			this.result.silver.small = this.round(this.input / this.rate.silver);
		},
		round(num) {
			num = parseInt(num * 10000, 10);
			return num / 10000;
		}
	}
}
	
</script>


// WEBPACK FOOTER //
// ratiocalc.vue?0f7980a8